import {   
    Component,
  } from '@angular/core';
  
  @Component({
    selector: 'pm-context-menu-divider',
    //templateUrl: './app/controls/components/context-menu/context-menu-divider.html',
    templateUrl: './context-menu-divider.html',
  })
  export class ContextMenuDividerComponent {
  }


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/context-menu/context-menu-divider-component.ts